import { render, staticRenderFns } from "./editor-preview-exam-question.vue?vue&type=template&id=38c38422&scoped=true&"
import script from "./editor-preview-exam-question.vue?vue&type=script&lang=js&"
export * from "./editor-preview-exam-question.vue?vue&type=script&lang=js&"
import style0 from "./editor-preview-exam-question.vue?vue&type=style&index=0&id=38c38422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c38422",
  null
  
)

export default component.exports